import "bootstrap/dist/css/bootstrap.min.css"
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
library.add(fas, far, fab)
dom.watch();
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { i18n } from 'vue-lang-router';
import "bootstrap/dist/js/bootstrap.js"
import AOS from "aos";
import "aos/dist/aos.css";
import Vue3Progress from "vue3-progress";
import './assets/css/virtualdomus.css';
import './assets/css/enric.css';

const roca = { firstTimeHere: true };
window.roca = roca;

const app = createApp(App)
    .use(router)
    .use(i18n)
    .use(AOS)
    .use(Vue3Progress)
    .component("font-awesome-icon", FontAwesomeIcon)
    .mount('#app');
app.AOS = new AOS.init();